<template>
  <ProductListing tax="category" :terms="{ category: slug }" />
</template>

<script lang="ts" setup>
import { ref } from "vue";
import ProductListing from "~/components/Product/ProductListing.vue";

const slug = ref<string[]>([]);
const route = useRoute()
const { pushToDataLayer, pushPageTypeToDataLayer } = useCustomGtm();

if (Array.isArray(route.params.slug)) {
  // console.log(route.params.slug, 'route.params.slug222222222');

  slug.value = route.params.slug.filter(value => value !== "");
} else if (typeof route.params.slug === 'string') {
  slug.value = route.params.slug !== "" ? [route.params.slug] : [];
} else {
  slug.value = [];
}

// definePageMeta middleware removed - API handles taxonomy validation
onMounted( ()=>{
  const routeslug = useRoute(); // Get the current route
  const pathSegments = routeslug.path.split('/').filter(segment => segment); 
  const pageType = 'category page'; 
  const hierachy1 = pathSegments[0] || 'n/a'; 
  const hierachy2 = pathSegments[1] || 'n/a'; 
  const hierachy3 = 'n/a';
  pushPageTypeToDataLayer(pageType, {
    hierachy1,
    hierachy2,
    hierachy3,
  });
})
</script>